/**
 * 公会城邦战 · 接口 data 类型
 * @see mockMd/*.md
 */

/** 活动标识 */
export enum UnionCityWarActivityName {
  UnionCityWar = 'union_city_war',
}

/** 用户身份 @see mockMd/union_city_war_homepage.md */
export enum UnionCityWarRole {
  /** 普通用户 */
  User = 1,
  /** 主播 */
  Anchor = 2,
}

/** 公会分层 @see mockMd/union_city_war_homepage.md */
export enum UnionCityWarTier {
  S = 's',
  A = 'a',
  B = 'b',
  C = 'c',
}

/** 赛段查询参数 @see mockMd/union_city_war_rank.md */
export enum UnionCityWarStageQuery {
  /** 当前赛段 */
  Current = 0,
  /** 小组赛 */
  Group = 1,
  /** 晋级赛 */
  Promotion = 2,
  /** 决赛 */
  Final = 3,
}

/** 实际赛段枚举 @see mockMd/union_city_war_homepage.md */
export enum UnionCityWarStage {
  /** 小组赛 */
  Group = 1,
  /** 晋级赛 */
  Promotion = 2,
  /** 决赛 */
  Final = 3,
}

/** 建筑等级奖励领取状态 @see mockMd/union_city_war_homepage.md */
export enum UnionCityWarBuildingRewardStatus {
  /** 未达等级不可领取 */
  Locked = 0,
  /** 可领取 */
  Claimable = 1,
  /** 已领取 */
  Claimed = 2,
}

/** 城建值记录来源 @see mockMd/union_city_war_score_record.md */
export enum UnionCityWarScoreRecordType {
  /** 收礼 */
  Gift = 1,
  /** 任务 */
  Task = 2,
  /** PK */
  Pk = 3,
}

/** 榜单晋级类型 @see mockMd/union_city_war_rank.md */
export enum UnionCityWarPromoteType {
  /** 未晋级 */
  None = 0,
  /** 排名晋级 */
  Rank = 1,
  /** 等级直通 */
  LevelDirect = 2,
  /** 排名且直通 */
  Both = 3,
}

/** 通用操作结果状态 */
export enum UnionCityWarActionStatus {
  Success = 1,
}

/** 提醒接口状态 @see mockMd/union_city_war_remind.md */
export enum UnionCityWarRemindStatus {
  Success = 1,
}

/** 房间挂件排序权重 @see mockMd/union_city_war_pendant.md */
export enum UnionCityWarPendantWeight {
  Default = 310,
}

/** 礼物城建倍率默认值 @see mockMd/union_city_war_homepage.md */
export enum UnionCityWarGiftBonus {
  /** 普通礼物加成默认倍率 */
  NormalDefault = 10,
  /** 特殊礼物加成默认倍率 */
  SpecialDefault = 15,
}

/** 通用活动平台奖励项 */
export interface UnionCityWarRewardItem {
  id: number
  name: string
  view_icon: string
  toast_name: string
  reward_type: number
  tag: string
  privilege_id?: number
  origin_id?: number
  quantity: number
  reward_value: number
  has_show_effect: boolean
  days?: number
}

/** 通用活动平台奖励信息项 */
export interface UnionCityWarRewardInfoItem {
  id: number
  activity_id: number
  origin_name: string
  view_icon: string
  toast_name: string
  reward_type: number
  reward_string: string
  reward_quantity: number
  reward_tag: string
  reward_value: number
  has_show_effect: boolean
}

/** PK 展示块 @see mockMd/union_city_war_pendant.md */
export interface UnionCityWarPendantPk {
  own_city_level: number
  opponent_city_level: number
  own_score: number
  opponent_score: number
}

/** 城建进度块 @see mockMd/union_city_war_pendant.md */
export interface UnionCityWarPendantCity {
  city_level: number
  city_score: number
  next_level_score: number
}

/** 当前小组榜 Top1 @see mockMd/union_city_war_pendant.md */
export interface UnionCityWarPendantTop1 {
  union_avatar: string
  city_score: number
}

/** 房间挂件载荷 @see mockMd/union_city_war_pendant.md */
export interface UnionCityWarPendantData {
  activity_name: UnionCityWarActivityName.UnionCityWar
  activity_id: number
  image: string
  url: string
  weight: UnionCityWarPendantWeight
  pk?: UnionCityWarPendantPk
  city?: UnionCityWarPendantCity
  top1?: UnionCityWarPendantTop1
}

export interface UnionCityWarHomepagePkSide {
  city_level: number
  union_name: string
  union_avatar: string
  city_score: number
  is_robot: boolean
}

export interface UnionCityWarHomepagePkInfo {
  slot_time: string
  end_countdown: number
  next_open_time: string
  own: UnionCityWarHomepagePkSide | null
  opponent: UnionCityWarHomepagePkSide | null
}

export interface UnionCityWarBuildingRewardItem {
  level: number
  status: UnionCityWarBuildingRewardStatus
  rewards: UnionCityWarRewardItem[]
}

export interface UnionCityWarRankRiseItem {
  union_id: number
  union_name: string
  union_avatar: string
}

export interface UnionCityWarStageRankItem {
  stage: UnionCityWarStage
  time_range: string
  countdown_sec: number
  promote_count: number
  direct_promote_level: number
  direct_promote_score: number
}

/** @see mockMd/union_city_war_homepage.md */
export interface UnionCityWarHomepageData {
  err_msg: string
  is_first_enter: boolean
  role: UnionCityWarRole
  is_leader: boolean
  union_id: number
  activity_id: number
  activity_time: string
  tier: UnionCityWarTier
  stage: UnionCityWarStage
  city_level: number
  city_score: number
  next_level_need: number
  direct_promote_left: number
  gift_city_score: number
  task_city_score: number
  pk_city_score: number
  sign_city_score: number
  sign_done: boolean
  gift_task_done: number
  gift_task_need: number
  gift_reward_city_score: number
  normal_gift_bonus: number
  special_gift_bonus: number
  pk_win_city_score: number
  pk_threshold: number
  anchor_threshold: number
  pk_start_time: string
  pk_end_time: string
  pk_slot_times: string[]
  pk_enable: boolean
  pk_box_rewards: UnionCityWarRewardInfoItem[]
  /** 主播：自己对阵（0/1 条）；普通用户：本场 PK 前 10；无对阵时为空数组 */
  pk_info: UnionCityWarHomepagePkInfo[]
  building_rewards: UnionCityWarBuildingRewardItem[]
  can_remind: boolean
  rank_rise_list: UnionCityWarRankRiseItem[]
  stage_list: UnionCityWarStageRankItem[]
}

/** @see mockMd/union_city_war_pk_switch.md */
export interface UnionCityWarPkSwitchData {
  status: UnionCityWarActionStatus
  enable: boolean
  err_msg: string
}

/** @see mockMd/union_city_war_level_reward_claim.md */
export interface UnionCityWarLevelRewardClaimData {
  status: UnionCityWarActionStatus
  err_msg: string
}

/** @see mockMd/union_city_war_remind.md */
export interface UnionCityWarRemindData {
  status: UnionCityWarRemindStatus
  remind_cnt: number
  err_msg: string
}

/** 排行区间奖励 @see mockMd/union_city_war_rank.md · union_city_war_rules.md */
export interface UnionCityWarRankRewardItem {
  /** 排行区间展示文案：`1` / `2,3` / `4,10` */
  rank_range: string
  threshold_a: number
  threshold_b: number
  threshold_c: number
  coin_a: number
  coin_b: number
  coin_c: number
  /** 该区间奖励；无标签或查询失败时为空数组 */
  reward_list: UnionCityWarRewardItem[]
}

export interface UnionCityWarRankItem {
  rank: number
  union_id: number
  union_avatar: string
  union_name: string
  city_score: number
  city_level: number
  coins: number
  is_promoted: UnionCityWarPromoteType
  can_get_reward: boolean
}

export interface UnionCityWarRankOwnItem extends UnionCityWarRankItem {
  prev_score_diff: number
}

/** @see mockMd/union_city_war_rank.md */
export interface UnionCityWarRankData {
  err_msg: string
  stage: UnionCityWarStage
  group_no: number
  page: number
  more: boolean
  countdown_sec: number
  promote_count: number
  direct_promote_level: number
  own_city_level: number
  own_city_score: number
  direct_promote_score: number
  rank_reward_list: UnionCityWarRankRewardItem[]
  list: UnionCityWarRankItem[]
  topn: number
  own: UnionCityWarRankOwnItem | null
}

export interface UnionCityWarGroupUnionItem {
  rank: number
  union_id: number
  union_avatar: string
  union_name: string
  city_score: number
}

/** @see mockMd/union_city_war_groups.md */
export interface UnionCityWarGroupsData {
  err_msg: string
  stage: UnionCityWarStage
  own_group: number
  groups: {[groupId: number]: UnionCityWarGroupUnionItem[]}
}

export interface UnionCityWarScoreRecordDay {
  date: string
  city_score: number
  normal_city_score: number
  exclusive_city_score: number
  sign_anchor_cnt: number
  gift_task_anchor_cnt: number
  sign_city_score: number
  gift_task_city_score: number
  pk_win_cnt: number
}

export interface UnionCityWarPkBoxRewardItem {
  time: string
  reward: UnionCityWarRewardInfoItem | null
}

/** @see mockMd/union_city_war_score_record.md */
export interface UnionCityWarScoreRecordData {
  err_msg: string
  total_city_score: number
  day_list: UnionCityWarScoreRecordDay[]
  box_rewards: UnionCityWarPkBoxRewardItem[]
}

export interface UnionCityWarPkSideItem {
  union_id: number
  union_name: string
  union_avatar: string
  city_score: number
  is_robot: boolean
}

export interface UnionCityWarPkMatchItem {
  left: UnionCityWarPkSideItem
  right: UnionCityWarPkSideItem
}

/** @see mockMd/union_city_war_pk_list.md · union_city_war_pk_search.md */
export interface UnionCityWarPkListData {
  err_msg: string
  page: number
  more: boolean
  list: UnionCityWarPkMatchItem[]
}

export interface UnionCityWarRulesStageItem {
  stage: UnionCityWarStage
  time_range: string
  direct_promote_level: number
  promote_count: number
  rank_reward_list: UnionCityWarRankRewardItem[]
  topn: number
}

export interface UnionCityWarCoreRewardItem {
  level: number
  rewards: UnionCityWarRewardItem[]
}

/** @see mockMd/union_city_war_rules.md */
export interface UnionCityWarRulesData {
  err_msg: string
  tier: UnionCityWarTier
  stage_list: UnionCityWarRulesStageItem[]
  anchor_threshold: number
  pk_win_city_score: number
  sign_city_score: number
  gift_reward_city_score: number
  core_rewards: UnionCityWarCoreRewardItem[]
}

/** @see mockMd/union_city_war_goto.md */
export interface UnionCityWarGotoData {
  err_msg: string
  room_id: number
  scheme: string
}
